import { Typography } from '@mui/material'
import type { PropsWithChildren } from 'react'

interface Props {
  color?: string
  variant?: 'default' | 'alternative'
}

export function Value(props: PropsWithChildren<Props>) {
  const { children, color = 'text.primary', variant = 'default' } = props

  const background = variant === 'default' ? 'background.default2' : undefined
  const paddingX = variant === 'default' ? 1.5 : 0
  const paddingY = variant === 'default' ? 2 : 0

  return (
    <Typography
      variant="body1"
      color={color}
      bgcolor={background}
      paddingX={paddingX}
      paddingY={paddingY}
      borderRadius={1}
      sx={{ userSelect: 'text' }}
    >
      {children}
    </Typography>
  )
}
